<app-modal [modalId]="id" title="Move user back to waitlist">
    <div class="filtercard">
        <p> Are you sure you want to move this user back to waitlist?</p>
        <div class="common_btn">
            <button id="btn-cancel-unapprove" data-dismiss="modal">Cancel</button>
            <button class="btn-submit" (click)="unApprove()">Yes</button>
        </div>
    </div>
</app-modal>